import { render, staticRenderFns } from "./SystemUserLogsDialog.vue?vue&type=template&id=88bf40ea&"
import script from "./SystemUserLogsDialog.vue?vue&type=script&lang=ts&"
export * from "./SystemUserLogsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports